import React, { useEffect, useState } from 'react';
import { navLinks } from '../mock';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BusinessSelector from './BusinessSelector';
import { useBusiness } from '../context/BusinessContext';

const Logo = () => (
  <div className="flex items-center gap-2">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="12" cy="12" r="3" fill="currentColor" />
      <path d="M12 1v22M1 12h22" stroke="currentColor" strokeWidth="0.6" opacity="0.5" />
    </svg>
    <span className="text-[15px] tracking-tight font-medium">grocera</span>
  </div>
);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth() || {};
  const { currentBusiness } = useBusiness();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-[#050506]/85 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 h-[64px] flex items-center justify-between text-white">
        <Logo />

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => {
            const isExternal = !l.href.startsWith('/') || l.href.startsWith('/#');
            if (l.href.startsWith('/#')) {
              return (
                <a key={l.label} href={l.href} className="eyebrow hover:text-white transition-colors">
                  {l.label}
                </a>
              );
            }
            return (
              <Link key={l.label} to={l.href} className="eyebrow hover:text-white transition-colors">
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          {user && currentBusiness && (
            <BusinessSelector />
          )}
          {!user && (
            <Link to="/login" className="btn-ghost text-[13px]">
              Login
            </Link>
          )}
          <a href="https://calendar.app.google/rUCGByUhUwE69b2T9" className="btn-primary text-[13px] whitespace-nowrap">
            <span className="hidden sm:inline">Schedule your Demo</span>
            <span className="sm:hidden">Demo</span>
            <ArrowRight size={14} />
          </a>
          {user && (
            <Link to="/tbs-dashboard" className="btn-ghost text-[12px] hidden md:inline-flex">
              Dashboard
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
